import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTicketAlt, faLock } from '@fortawesome/free-solid-svg-icons';
import { LinkContainer } from 'react-router-bootstrap';
import { getCurrencyValue, getTicketsTotal, getFeeTotal, getCartTotal, renderPrice } from '../../libs/cartLib';
import LoaderButton from '../../components/common/LoaderButton';

export default function CartSummaryCard({ cart, getTotalItems, mode = 'readonly', onPay, onModify, isLoading }) {
  // const [isLoading, setIsLoading] = useState(false);

  const ticketsTotal = getTicketsTotal(cart);
  const feeTotal = getFeeTotal(cart);
  const cartTotal = getCartTotal(cart);

  useEffect(() => {
    console.log('isLoading', isLoading);
  }, [isLoading]);


  return (
    <div className="cart-summary-box cart-summary-box-card">
      <div className="cart-summary-title">Resumen de compra</div>
      <div className="cart-summary-row">
        <span>Subtotal Boletos</span>
        <span>{renderPrice(cart, ticketsTotal)}</span>
      </div>
      <div className="cart-summary-row">
        <span>Cargo por servicio de boletería</span>
        <span>+ {renderPrice(cart, feeTotal)}</span>
      </div>
      <div className="cart-summary-divider"></div>
      <div className="cart-summary-row cart-summary-total-row">
        <span className="cart-summary-total-label">TOTAL</span>
        <span className="cart-summary-total-value">{renderPrice(cart, cartTotal)}</span>
      </div>
      {mode === 'checkout' && (
        <>
          <LinkContainer to="/cart/checkout">
            <button className="btn-theme-primary" disabled={getTotalItems(cart) === 0}>
              <FontAwesomeIcon icon={faTicketAlt} /> Finalizar la Compra
            </button>
          </LinkContainer>
          {/* <div className="cart-summary-payment-label">Métodos de pago aceptados:</div>
          <div className="cart-summary-payment-icons">
            <span className="cart-payment-icon"></span>
            <span className="cart-payment-icon"></span>
            <span className="cart-payment-icon"></span>
          </div> */}
        </>
      )}
      {mode === 'payment' && (
        <>
          <LoaderButton
            className="btn-theme-primary"
            style={{ marginBottom: 16 }}
            onClick={onPay}
            disabled={!onPay}
            isLoading={isLoading}
          >
            <FontAwesomeIcon icon={faLock} /> Pagar
          </LoaderButton>
          <button
            className="btn-theme-secondary"
            onClick={onModify}
          >
            Modificar orden
          </button>
        </>
      )}
    </div>
  );
} 